import React,{Component} from 'react';
import {Event} from '../../common/event';
import ScrollArea from "react-scrollbar";
export default class Selector extends Component{
  constructor(props) {
    super(props);
    let defaultItem = this.defaultSelected(this.props);
    this.state = {
      selectedItem : defaultItem
    };
    this.activeChange(defaultItem);
  }


  getMatchColor(colorid,productId) {
    let specialProduct= [1,6,7,8,9,10,11,12,14];
    if(specialProduct.indexOf(productId) > -1) {
      let id;
      switch(colorid) {
        case 1:
          id = 29;
          break;
        case 2:
          id = 9;
          break;
        case 3:
          id = 10;
          break;
        case 4:
          id = 11;
          break;
        default:
          id = colorid;
          break;
      }
      return id;
    }
    return colorid;   
  }

  defaultSelected(props) {
    let {defaultSelected,lists} = props;
    if(defaultSelected !== undefined) {
      let colorid = this.getMatchColor(defaultSelected.id,defaultSelected.productId);
      let target = lists.find(v=>v.id === colorid);
      if(target) {
        return target;
      }
    }
    return lists[0];
  }


  componentWillReceiveProps(nextProps) {
    if(nextProps.defaultSelected) {
      let defaultItem = this.defaultSelected(nextProps);
      //取消无更新渲染
      if(this.state.selectedItem && (nextProps.lists[0].productId == this.props.lists[0].productId) && (defaultItem.id == this.state.selectedItem.id)) {
        return false;
      }
      //更新渲染
      this.activeChange(defaultItem);
      return; 
    }

    //取消无更新渲染  
    if(nextProps.lists[0].productId == this.props.lists[0].productId) {
      if(this.state.selectedItem) {
        let target = nextProps.lists.find(v=>v.id === this.state.selectedItem.id);
        if(target) {
          return false;
        }
      }
    }

    //更新渲染
    let defaultItem = this.defaultSelected(nextProps);
    this.activeChange(defaultItem);
  }

  render() {

    if(this.props.type == 3){
      let options = this.getScrollParams(this.props.type,this.props.lists.length);
      return (
          <div className="out-container">
            <ScrollArea {...options}>
              <ul className="selector">
                {
                  this.props.lists.map((data)=>(
                      <li key={data.id}>
                        { this.geometry(data) }
                      </li>
                  ))
                }
              </ul>
            </ScrollArea>
          </div>
      );
    }else if(this.props.lists.length > 4) {
      let options = this.getScrollParams(this.props.type,this.props.lists.length);
      return (
        <ScrollArea {...options}>
          <ul className="selector">
            {
              Array.from(this.props.lists.keys()).map((key)=>{
                let current = this.props.lists[key];
                if(current.color) {
                  if(key % 2 == 0) {
                    let next = this.props.lists[key + 1];
                    return (
                        <li key={current.id}>
                          {this.color(current)}
                          {next && this.color(next)}
                        </li>
                    );
                  }
                }else if(current.pngPath) {
                  if(key < 3) {
                    let next = this.props.lists[key + 3];
                    return (
                        <li key={current.id}>
                          {this.geometry(current)}
                          {next && this.geometry(next)}
                        </li>
                    );
                  }
                }
              })
            }
          </ul>
        </ScrollArea>
      );
    }
    return (
      <div className="sub-selector">
        <ul className="selector">
          {
            this.props.lists.map((data)=>(
                <li key={data.id}>
                  { data.color && this.color(data) }
                  { data.pngPath && this.geometry(data) }
                </li>
            ))
          }
        </ul>
      </div>
    );

  }

  activeChange(e) {
    if(e.type == 3) {
      Event.emit('WindowChange', e);
      this.setState({selectedItem: e});
    }else{
      Event.emit('SelectorChange', e);
      Event.emit('ShowRight', e);
      this.setState({selectedItem: e});
      if(this.props.type !== -1) {
        this.props.callback(e);
      }
    }
  }

  geometry(data) {
    return(
      <a key={data.id} className={(this.state.selectedItem && this.state.selectedItem.id === data.id) ? 'selected' : null}
         onClick={this.activeChange.bind(this,data)}>
        <div>
          <img src={process.env.PUBLIC_URL + data.pngPath}></img>
        </div>
        <p>{data.name}</p>
      </a>
    );
  }

  color(data) {
    return(
      <a key={data.id} className={(this.state.selectedItem && this.state.selectedItem.id === data.id) ? 'selected' : null}
          onClick={this.activeChange.bind(this,data)}>
        <div style={{background: data.color}}></div>
        <p>{data.name}</p>
      </a>
    );
  }

  getScrollParams(type,length) {
    let horizontal = null,
        vertical = null,
        contentStyle = null,
        className = null,
        horizontalContainerStyle = null,
        horizontalScrollbarStyle = null,
        verticalContainerStyle = null,
        verticalScrollbarStyle = null;
    if(type == 3) {
      vertical = true;
      console.log(length,Math.ceil(length/4));
      let height = 90 * Math.ceil(length/4);
      contentStyle = {
        height: `${height}px`
      };
      className = 'main-selector vertical';
      verticalContainerStyle = {borderRadius: '6px',background: '#c0cdde',width: '5px'};
      verticalScrollbarStyle = {borderRadius: '6px',background: '#6285b2',width: '5px', marginTop: 0 };
    }else{
      horizontal = true;
      let width = 69 * Math.ceil(length / 2) - 12;
      contentStyle = {
        width: `${width}px`
      };
      className = 'main-selector';
      horizontalContainerStyle = {borderRadius: '6px',background: '#c0cdde',height: '10px'};
      horizontalScrollbarStyle = {borderRadius: '6px',background: '#6285b2',height: '10px', marginTop: 0 };
    }
    return {vertical,horizontal,className,contentStyle,verticalContainerStyle,verticalScrollbarStyle,horizontalContainerStyle,horizontalScrollbarStyle}
  }

}
